import { DateTime } from "luxon";
import * as z from "zod";

const daysOfWeekSchema = z.union([
  z.literal("monday"),
  z.literal("tuesday"),
  z.literal("wednesday"),
  z.literal("thursday"),
  z.literal("friday"),
  z.literal("saturday"),
  z.literal("sunday"),
]);
export type DayOfWeek = z.infer<typeof daysOfWeekSchema>;
const ScheduleTypeSchema = z.union([
  z.literal("open_hours"),
  z.literal("ordering_hours"),
]);
export type ScheduleType = z.infer<typeof ScheduleTypeSchema>;
export const ScheduledTimeSchema = z.object({
  id: z.number(),
  uuid: z.string(),
  day: daysOfWeekSchema,
  startTime: z
    .string()
    .min(2, "Start Time is required")
    .transform((v) =>
      DateTime.fromISO(v).toISOTime({
        suppressMilliseconds: true,
        suppressSeconds: true,
        includeOffset: false,
      }),
    ),
  endTime: z
    .string()
    .min(2, "End Time is required")
    .transform((v) =>
      DateTime.fromISO(v).toISOTime({
        suppressMilliseconds: true,
        suppressSeconds: true,
        includeOffset: false,
      }),
    ),
  weeklyScheduleUuid: z.string(),
});
export const ScheduledTimesSchema = z.array(ScheduledTimeSchema);
export type ScheduledTime = z.infer<typeof ScheduledTimeSchema>;
export const daysOfWeek: DayOfWeek[] = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export const WeeklyScheduleSchema = z.object({
  id: z.number(),
  uuid: z.string(),
  message: z.string().nullable(),
  scheduleType: ScheduleTypeSchema.catch("ordering_hours"),
});
export const WeeklySchedulesSchema = z.array(WeeklyScheduleSchema);
export type WeeklySchedule = z.infer<typeof WeeklyScheduleSchema>;
